import { ComponentProps } from 'react';

import { Control, Controller, Path } from 'react-hook-form';

import { QuotationProductsMargin } from 'components/quotation-editor/quotation-products/QuotationProductsMargin';

interface ProfitMarginControlledProps<T>
    extends Omit<
        ComponentProps<typeof QuotationProductsMargin>,
        'margin' | 'handleChange'
    > {
    control: Control<T>;
    name: Path<T>;
}

const ProfitMarginControlled = <T,>({
    control,
    name,
    ...props
}: ProfitMarginControlledProps<T>) => {
    return (
        <Controller
            control={control}
            name={name}
            render={({ field: { value, onChange } }) => (
                <QuotationProductsMargin
                    {...props}
                    margin={Number(value)}
                    handleChange={({ margin }) => onChange(margin)}
                />
            )}
        />
    );
};

export default ProfitMarginControlled;
